import {
  ApplicationRef,
  Component,
  ElementRef,
  HostListener,
} from '@angular/core';
import { DashboardService } from './dashboard.service';
import { EsListComponent } from '../_widgets/es-list/es-list.component';
import { PgmListComponent } from '../_widgets/pgm-list/pgm-list.component';
import { SpListComponent } from '../_widgets/sp-list/sp-list.component';
import { MapVecComponent } from '../_widgets/map-vec/map-vec.component';
import { AlarmeListComponent } from '../_widgets/alarme-list/alarme-list.component';
import { MapEditComponent } from '../_widgets/map-edit/map-edit.component';
import { AvancementListComponent } from '../_widgets/avancement-list/avancement-list.component';
import { EquipmentListComponent } from '../_widgets/equipement-list/equipment-list.component';
import { LogListComponent } from '../_widgets/log-list/log-list.component';
import { HistoriqueComponent } from '../_widgets/historique/historique.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent {
  private readonly HEADER_FOOTER_HEIGHT = 64;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.resizeDashboard(event.target as Window);
  }

  constructor(
    private elRef: ElementRef<HTMLElement>,
    private appRef: ApplicationRef,
    private dashboardService: DashboardService
  ) {
    this.dashboardService.registerComponent(
      'EsListComponent',
      EsListComponent
    );
    this.dashboardService.registerComponent(
      'PgmListComponent',
      PgmListComponent
    );
    this.dashboardService.registerComponent(
      'SpListComponent',
      SpListComponent
    );
    this.dashboardService.registerComponent(
      'MapVecComponent',
      MapVecComponent
    );
    this.dashboardService.registerComponent(
      'MapEditComponent',
      MapEditComponent
    );
    this.dashboardService.registerComponent(
      'EquipmentListComponent',
      EquipmentListComponent
    );
    this.dashboardService.registerComponent(
      'AvancementListComponent',
      AvancementListComponent
    );
    this.dashboardService.registerComponent(
      'AlarmeListComponent',
      AlarmeListComponent
    );
    this.dashboardService.registerComponent(
      'LogListComponent',
      LogListComponent
    );
    this.dashboardService.registerComponent(
      'HistoriqueComponent',
      HistoriqueComponent
    );
  }

  initialize(): void {
    this.dashboardService.initialize(this.elRef, this.appRef);
    this.resizeDashboard(window);
  }

  private resizeDashboard(win: Window): void {
    const width = win.innerWidth;
    const height = win.innerHeight - this.HEADER_FOOTER_HEIGHT;
    this.dashboardService.setSize(width, height);
  }
}
